export default "__VITE_ASSET__C1j7Q2kN__"